module.exports = __webpack_public_path__ + "static/img/role.df25220.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/kc/role.png
// module id = gk5y
// module chunks = 7